import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Layout } from '../../containers/Layout'
import { UrlHelper } from '../../helpers/UrlHelper'
import { clearSchoolList, getSchoolById } from '../../states/schools/actions'
import { Searching } from '../../containers/SchoolSearchResult/Searching'
import { STYLES } from '../../static/style'
import { SchoolDetailsToolbar } from '../../containers/SchoolDetailsToolbar'
import { SchoolNavigationHelper } from '../../helpers/NavigationHelper/SchoolNavigationHelper'
import { SchoolPageCarouselView } from '../../containers/SchoolPageCarouselView'
import { SchoolListingViewAllModal } from '../../containers/SchoolListing/SchoolListingViewAllModal'
import { SchoolListingDetailsModal } from '../../containers/SchoolListing/SchoolListingDetailsModal'
import { ExternalWebsiteModal } from '../../components/Modal/ExternalWebsiteModal'
import { AddListingModal } from '../../containers/Modal/AddListingModal'
import { ChangeRequestSubmittedModal } from '../../containers/Modal/ChangeRequestSubmittedModal'
import { UpdateListingModal } from '../../containers/Modal/UpdateListingModal'
import { SubscribeSection } from '../../containers/Subscription/SubscribeSection'
import { AroundSchoolsSEO } from '../../containers/Page/AroundSchoolsSEO'
import EditSchoolModal from '../../containers/Modal/EditSchoolModal'
import { IPageProps } from '../../types/Page.types'
import EducationOrganizationJsonLd from '../../components/JsonLd/EducationOrganizationJsonLd'

const StyledSchoolDetailsPage = styled(Layout)`
  box-sizing: border-box;
  font-size: ${STYLES.FONT_SIZE_MD};
  line-height: 1.6rem;
`

const SchoolDetailsPage: React.FC<IPageProps> = ({
  location: { pathname },
  pageResources,
}: any) => {
  const dispatch = useDispatch()
  const urlValues = UrlHelper.getUrlValues(pathname, pageResources)
  const schoolId = urlValues[1]
  const { schools: schoolState } = useSelector(({ schools }: any) => ({
    schools,
  }))
  const schools = schoolState.list
  const currentSchoolIndex = schools.findIndex((s: any) => s.id === schoolId)
  const [slideIndex, setSlideIndex] = useState(
    currentSchoolIndex === -1 ? 0 : currentSchoolIndex
  )
  const school = schools[currentSchoolIndex]
  useEffect(() => {
    if (currentSchoolIndex === -1) {
      dispatch(clearSchoolList())
      setSlideIndex(0)
    } else {
      setSlideIndex(currentSchoolIndex)
    }
    // setTimeout to prevent details page go blank
    setTimeout(() => dispatch(getSchoolById(schoolId)), 50)
  }, [dispatch, schoolId, currentSchoolIndex])

  if (!school) {
    return (
      <StyledSchoolDetailsPage pathname={pathname}>
        {schoolState.isFetching && <Searching />}
      </StyledSchoolDetailsPage>
    )
  }
  const { about } = school
  let slideChangeTimeout: any
  const goToPage = (index: any) => {
    setSlideIndex(index)
    if (slideChangeTimeout) {
      clearTimeout(slideChangeTimeout)
    }
    slideChangeTimeout = setTimeout(() => {
      SchoolNavigationHelper.navigateToSchoolPage({ school: schools[index] })
    }, 300)
  }
  return (
    <StyledSchoolDetailsPage pathname={pathname}>
      <AroundSchoolsSEO
        title={school.name}
        description={about}
        pathname={pathname}
      />
      <EducationOrganizationJsonLd school={school} />
      <SchoolDetailsToolbar
        schoolId={schoolId}
        onNextClick={goToPage}
        onPrevClick={goToPage}
      />
      <SchoolPageCarouselView
        schools={schools}
        slideIndex={slideIndex}
        onSlideChange={goToPage}
      />
      <SchoolListingViewAllModal />
      <SchoolListingDetailsModal />
      <ExternalWebsiteModal />
      <AddListingModal />
      <ChangeRequestSubmittedModal />
      <UpdateListingModal />
      <SubscribeSection />
      <EditSchoolModal />
    </StyledSchoolDetailsPage>
  )
}

export default SchoolDetailsPage
